const PATH = 'fe.components.calibrations.calibration_bottom_section';

const messages = {
  exitTest: {
    key: `${PATH}.exit_test`,
    defaultValue: 'Save and Exit'
  },
  reviewVideo: {
    key: `${PATH}.review_video`,
    defaultValue: 'Review Video'
  },
  continue: {
    key: `${PATH}.continue`,
    defaultValue: 'Continue'
  }
};

export default messages;
